// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function GlobeIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M16 3a13 13 0 1 0 13 13A13.013 13.013 0 0 0 16 3Zm-3.296 18h6.592c-.671 2.293-1.796 4.359-3.296 5.986-1.5-1.627-2.625-3.694-3.296-5.986Zm-.454-2a18.213 18.213 0 0 1 0-6h7.5a18.213 18.213 0 0 1 0 6h-7.5ZM5 16c0-1.014.14-2.024.416-3h4.808a20.22 20.22 0 0 0 0 6H5.416A10.951 10.951 0 0 1 5 16Zm14.296-5h-6.592C13.375 8.707 14.5 6.641 16 5.014 17.5 6.64 18.625 8.707 19.296 11Zm2.48 2h4.808a11.019 11.019 0 0 1 0 6h-4.808a20.226 20.226 0 0 0 0-6Zm4.02-2h-4.428a17.799 17.799 0 0 0-2.533-5.625A11.046 11.046 0 0 1 25.796 11ZM13.165 5.375A17.799 17.799 0 0 0 10.633 11h-4.43a11.046 11.046 0 0 1 6.962-5.625ZM6.204 21h4.429a17.799 17.799 0 0 0 2.532 5.625A11.047 11.047 0 0 1 6.204 21Zm12.631 5.625A17.799 17.799 0 0 0 21.367 21h4.43a11.047 11.047 0 0 1-6.962 5.625Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
